import HeadingMedia from './heading-media';
import { nanoid } from 'nanoid';

import { isIE } from '../utils/browsers';

class MastHeadMedia extends HeadingMedia {
  setupDefaults() {
    this.dom = {
      $image: this.el._$('img.masthead-media__media'),
      $mediaWrapper: this.el._$('.masthead-media__media-wrapper')
    };

    this.playButtonLabel = this.el.dataset.playButtonLabel;
    this.videoId = this.el.dataset.videoId;
    this.videoTitle = this.el.dataset.videoTitle;
    this.containerId = `video-${nanoid()}`;
    this.checkImage();
    this.addVideoPlayer();
  }

  getIframe() {
    return isIE
      ? `
      <div class="masthead-media__video" tabindex="-1" aria-hidden="true">
        <iframe
          loading="lazy"
          src="https://www.youtube.com/embed/${this.videoId}"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen="allowfullscreen"
          msallowfullscreen="msallowfullscreen"
          webkitallowfullscreen="webkitallowfullscreen"
          title="${this.videoTitle}"
          tabindex="-1"
        ></iframe>
      </div>
    `
      : `
      <div class="masthead-media__video" tabindex="-1" aria-hidden="true">
        <div class="${this.containerId}" tabindex="-1"></div>
      </div>
    `;
  }

  removeImage() {
    const { $image, $mediaWrapper } = this.dom;
    const $videoWrapper = $mediaWrapper._$('.masthead-media__video');

    if ($image) {
      $image.style.opacity = 0;
      $videoWrapper.style.zIndex = 1;
    }
  }
}

export default MastHeadMedia;
